var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57935 9.61465V13.4622C2.57935 17.3098 4.1218 18.8523 7.96938 18.8523H12.5882C16.4358 18.8523 17.9782 17.3098 17.9782 13.4622V9.61465",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.283 10.283C11.8512 10.283 13.0081 9.00623 12.8538 7.43807L12.2882 1.71384H8.28642L7.71229 7.43807C7.55804 9.00623 8.71488 10.283 10.283 10.283Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8533 9.85458C17.5842 9.85458 18.6895 8.87769 18.5181 7.15528L18.2782 4.79875C17.9697 2.57076 17.1128 1.71384 14.8676 1.71384H12.254L12.8539 7.72085C12.9995 9.13477 14.4393 9.85458 15.8533 9.85458Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83298 10.283C6.2469 10.283 7.52371 9.13477 7.66082 7.72085L7.84934 5.82706L8.26066 1.71384H5.64705C3.40192 1.71384 2.545 2.57076 2.23651 4.79875L2.00514 7.15528C1.83375 8.87769 3.102 10.283 4.83298 10.283Z",
    stroke: "white",
    strokeWidth: 1.28538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.5400787717e4f630320e02fa56a512e2.svg";
export { ForwardRef as ReactComponent };